import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/graphic/file.svg'


const _withScopeId = n => (_pushScopeId("data-v-78b3ddf0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "file-item" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "casedrive file"
}, null, -1))
const _hoisted_3 = {
  key: 1,
  class: "reshare-indicator"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-share" }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: 0,
  class: "file-item-author"
}
const _hoisted_7 = { class: "item-wrapper" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  key: 1,
  class: "item-author-info"
}
const _hoisted_10 = {
  key: 0,
  class: "name"
}
const _hoisted_11 = ["src"]
const _hoisted_12 = {
  key: 0,
  class: "checker checked"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-check" }, null, -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = {
  key: 1,
  class: "checker unchecked"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_question_pop_up = _resolveComponent("app-question-pop-up")!
  const _component_mixed_media_pop_up = _resolveComponent("mixed-media-pop-up")!
  const _component_app_rename_file = _resolveComponent("app-rename-file")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: _normalizeClass({ 'file-item-wrapper': _ctx.columnView }),
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openFile && _ctx.openFile(...args)))
    }, [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        (!!_ctx.file.share && !_ctx.isNetwork)
          ? (_openBlock(), _createElementBlock("i", {
              key: 0,
              class: _normalizeClass(["icon icon-users", { 'file-item-shared': _ctx.columnView }])
            }, null, 2))
          : _createCommentVNode("", true),
        (_ctx.reshareAllowed)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
          : _createCommentVNode("", true)
      ]),
      (!_ctx.hideAuthor)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              (!_ctx.hideTitle)
                ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_ctx.file.name), 1))
                : _createCommentVNode("", true),
              (_ctx.isNetwork)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    (_ctx.columnView && !_ctx.mainStore.isMobile)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(_ctx.authorName), 1))
                      : _createCommentVNode("", true),
                    (_ctx.photoUrl)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 1,
                          class: "photo",
                          src: _ctx.photoUrl
                        }, null, 8, _hoisted_11))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ]),
            (_ctx.showMenuDots)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.isMediaSettingsPopUp = true), ["prevent","stop"])),
                  class: "icon icon-dots file-item-option"
                }))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ], 2),
    (_ctx.selector)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (_ctx.file.selected || _ctx.isSelectedFromParent)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_14))
            : (_openBlock(), _createElementBlock("div", _hoisted_15))
        ], 64))
      : _createCommentVNode("", true),
    (_ctx.isQuestionPopUp)
      ? (_openBlock(), _createBlock(_component_app_question_pop_up, {
          key: 1,
          onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isQuestionPopUp = false)),
          onDelete: _ctx.deleteFile
        }, null, 8, ["onDelete"]))
      : _createCommentVNode("", true),
    (_ctx.isMediaSettingsPopUp)
      ? (_openBlock(), _createBlock(_component_mixed_media_pop_up, {
          key: 2,
          file: _ctx.file,
          onClosePopUp: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isMediaSettingsPopUp = false)),
          onOpenFileRename: _cache[4] || (_cache[4] = ($event: any) => (_ctx.fileRenamePopUp = true))
        }, null, 8, ["file"]))
      : _createCommentVNode("", true),
    (_ctx.fileRenamePopUp)
      ? (_openBlock(), _createBlock(_component_app_rename_file, {
          key: 3,
          file: _ctx.file,
          "mount-error-info": _ctx.renameMountErrorInfo,
          onClose: _cache[5] || (_cache[5] = ($event: any) => (_ctx.fileRenamePopUp = false)),
          onClearMountErrorInfo: _cache[6] || (_cache[6] = ($event: any) => (_ctx.renameMountErrorInfo = undefined))
        }, null, 8, ["file", "mount-error-info"]))
      : _createCommentVNode("", true)
  ]))
}